// @ts-nocheck
import "./ProductRating.scss";

import { Component, h, render } from "preact";
import { Connect, Provider } from "redux-zero/preact";

import { StarIcon } from "../Icon/icons/fill/StarIcon";
import { StarOutlineIcon } from "../Icon/icons/outlined/StarOutlinedIcon";
import { Theme } from "../Theme";
import store from "@store/store";

const mapToProps = ({ products }) => ({ products });

function Stars({ productUid, onClick = () => {} }) {
  return (
    <Theme widget="starsWidget">
      <Provider store={store}>
        <Connect mapToProps={mapToProps}>
          {({ products }) => {
            const product = products[productUid];
            const rating = product ? product.rating : 0;
            const reviews = product ? product.reviews_count : 0;

            return (
              <button className="CCProductRating" onClick={onClick}>
                <div className="CCProductRating__stars">
                  <div
                    className="CCProductRating__stars_fill"
                    style={`--cc-rating-width: ${(rating / 5) * 100}%`}
                  >
                    {new Array(5).fill(<StarIcon />)}
                  </div>
                  <div className="CCProductRating__stars_outline">
                    {new Array(5).fill(<StarOutlineIcon />)}
                  </div>
                </div>

                <div className="CCProductRating__rating t-text">
                  {Number(rating).toFixed(1)}
                </div>

                <div className="CCProductRating__reviews-count t-text">
                  ({reviews})
                </div>
              </button>
            );
          }}
        </Connect>
      </Provider>
    </Theme>
  );
}

export default Stars;
